import { Box, Flex, Text, Link } from '@chakra-ui/react';
import { useState } from 'react';

interface ExpertiseBoxProps {
    title: string;
    icon: JSX.Element;
    color: string;
    link?: string;
}

/**
 * 
 */
export default function SkillBox(props: ExpertiseBoxProps) {

    const [ hoverColor, setHoverColor ] = useState("#F9FAFB")

  return (
    <Link
        href={props.link}
        isExternal
        _hover={{ textDecoration: "none" }}
    >
        <Flex
            flexDirection={"column"}
            alignItems={"center"}
            justifyContent={"center"}
            width={{ base: "120px", md: "200px" }}
            height={{ base: "100px", md: "120px" }}
            padding={"2%"}
            onMouseEnter={() => setHoverColor(props.color)}
            onMouseLeave={() => setHoverColor("#F9FAFB")}
        >
            <Box
                color={hoverColor}
                fontSize={"6xl"}
                flex={1}
                alignItems={"center"}
                justifyContent={"center"}
                transition={"color 0.1s ease"}
            >
                {props.icon}
            </Box>

            <Text
                color={hoverColor}
                fontSize={"lg"}
                fontFamily={"Source Code Pro Variable"}
                fontWeight="600"
                textAlign="center"
                transition={"color 0.1s ease"}
            >
                {props.title}
            </Text>
        </Flex>
    </Link>
  );
};
